import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "rounded-lg border border-slate-200"
};
const _hoisted_2 = {
  class: "flex items-center justify-between border-b border-slate-200 px-4 py-3"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_5 = {
  class: "data-table-scroll"
};
const _hoisted_6 = {
  class: "data-table text-sm"
};
const _hoisted_7 = {
  class: "data-table-head"
};
const _hoisted_8 = {
  key: 0,
  class: "data-table-th text-right"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["colspan"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = ["colspan"];
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = ["type", "checked", "onChange"];
const _hoisted_15 = {
  class: "data-table-td font-mono text-xs text-slate-900"
};
const _hoisted_16 = {
  class: "data-table-td is-right"
};
const _hoisted_17 = {
  class: "data-table-td is-right"
};
const _hoisted_18 = {
  class: "data-table-td"
};
const _hoisted_19 = {
  key: 0,
  class: "data-table-td is-right"
};
const _hoisted_20 = ["value", "disabled", "onInput"];
const _hoisted_21 = {
  key: 0,
  class: "flex items-center justify-between border-t border-slate-200 px-4 py-3 text-sm"
};
const _hoisted_22 = {
  class: "text-slate-500"
};
const _hoisted_23 = {
  class: "font-medium text-slate-900"
};
import { computed, reactive, ref, watch } from 'vue';
import { getWealthContractBatchPage } from '@/api/wealth';
import { formatDate, formatMoney, formatRate, toNumber } from '../utils';
export default {
  __name: 'WealthBatchSelector',
  props: {
    contractId: {
      type: Number,
      default: null
    },
    mode: {
      type: String,
      default: 'decrease'
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    selectedBatchId: {
      type: Number,
      default: null
    }
  },
  emits: ['update:modelValue', 'update:selectedBatchId', 'select-row'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const rows = ref([]);
    const loading = ref(false);
    const selectedIds = ref([]);
    const amountMap = reactive({});
    const selectedItems = computed(() => selectedIds.value.map(id => ({
      batchId: id,
      amount: toNumber(amountMap[id])
    })).filter(item => item.batchId));
    const totalAmount = computed(() => selectedItems.value.reduce((sum, item) => sum + toNumber(item.amount), 0));
    async function loadBatches() {
      if (!props.contractId) {
        rows.value = [];
        return;
      }
      loading.value = true;
      try {
        const result = await getWealthContractBatchPage(props.contractId, {
          page: 1,
          size: 200,
          status: 'ACTIVE'
        });
        rows.value = result?.records || [];
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    }
    function isSelected(id) {
      return props.mode === 'decrease' ? selectedIds.value.includes(id) : props.selectedBatchId === id;
    }
    function toggleRow(row, event) {
      if (props.mode === 'decrease') {
        if (event.target.checked) {
          selectedIds.value = [...new Set([...selectedIds.value, row.id])];
          if (!amountMap[row.id]) amountMap[row.id] = row.remainingPrincipalAmount;
        } else {
          selectedIds.value = selectedIds.value.filter(id => id !== row.id);
          delete amountMap[row.id];
        }
        emit('update:modelValue', selectedItems.value);
        return;
      }
      emit('update:selectedBatchId', row.id);
      emit('select-row', row);
    }
    function updateAmount(id, value) {
      amountMap[id] = value;
      emit('update:modelValue', selectedItems.value);
    }
    watch(() => props.modelValue, value => {
      if (props.mode !== 'decrease') return;
      selectedIds.value = (value || []).map(item => item.batchId);
      Object.keys(amountMap).forEach(key => delete amountMap[key]);
      (value || []).forEach(item => {
        amountMap[item.batchId] = item.amount;
      });
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.contractId, () => {
      selectedIds.value = [];
      Object.keys(amountMap).forEach(key => delete amountMap[key]);
      emit('update:modelValue', []);
      loadBatches();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", null, [_createElementVNode("h4", {
        class: "text-sm font-semibold text-slate-900"
      }, "选择批次"), _createElementVNode("p", {
        class: "mt-0.5 text-xs text-slate-500"
      }, "只展示当前合同下可查询批次，提交时以后端状态校验为准。")], -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        disabled: !__props.contractId || loading.value,
        onClick: loadBatches
      }, "刷新", 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("table", _hoisted_6, [_createElementVNode("thead", _hoisted_7, [_createElementVNode("tr", null, [_cache[1] || (_cache[1] = _createElementVNode("th", {
        class: "data-table-th text-left w-10"
      }, "选择", -1)), _cache[2] || (_cache[2] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "批次编号", -1)), _cache[3] || (_cache[3] = _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "剩余本金", -1)), _cache[4] || (_cache[4] = _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "年利率（%）", -1)), _cache[5] || (_cache[5] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "到期日", -1)), __props.mode === 'decrease' ? (_openBlock(), _createElementBlock("th", _hoisted_8, "减资金额")) : _createCommentVNode("", true)])]), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [_createElementVNode("td", {
        colspan: __props.mode === 'decrease' ? 6 : 5,
        class: "data-table-empty"
      }, "加载中...", 8, _hoisted_10)])) : rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [_createElementVNode("td", {
        colspan: __props.mode === 'decrease' ? 6 : 5,
        class: "data-table-empty"
      }, "暂无可选批次", 8, _hoisted_12)])) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 2
      }, _renderList(rows.value, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.id,
          class: "data-table-row"
        }, [_createElementVNode("td", _hoisted_13, [_createElementVNode("input", {
          type: __props.mode === 'decrease' ? 'checkbox' : 'radio',
          class: "form-check",
          checked: isSelected(row.id),
          onChange: $event => toggleRow(row, $event)
        }, null, 40, _hoisted_14)]), _createElementVNode("td", _hoisted_15, _toDisplayString(row.batchNo), 1), _createElementVNode("td", _hoisted_16, "¥" + _toDisplayString(_unref(formatMoney)(row.remainingPrincipalAmount)), 1), _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatRate)(row.annualRate)), 1), _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatDate)(row.maturityDate)), 1), __props.mode === 'decrease' ? (_openBlock(), _createElementBlock("td", _hoisted_19, [_createElementVNode("input", {
          value: amountMap[row.id] || '',
          type: "number",
          min: "0",
          step: "0.01",
          class: "form-input form-control-sm w-32 text-right",
          disabled: !isSelected(row.id),
          onInput: $event => updateAmount(row.id, $event.target.value)
        }, null, 40, _hoisted_20)])) : _createCommentVNode("", true)]);
      }), 128))])])])]), __props.mode === 'decrease' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, "已选 " + _toDisplayString(selectedItems.value.length) + " 个批次", 1), _createElementVNode("span", _hoisted_23, "合计减资：¥" + _toDisplayString(_unref(formatMoney)(totalAmount.value)), 1)])) : _createCommentVNode("", true)]);
    };
  }
};